import { DecoratorValueProviderType } from '@baserow/modules/database/decoratorValueProviders'
import { matchSearchFilters } from '@baserow/modules/database/utils/view'

import FormaColorPorSeleccion from '@extras_mg/components/FormaColorPorSeleccion'
import FormaColorCondicional from '@extras_mg/components/FormaColorCondicional'
import {
  BordeIzquierdoColorViewDecoratorType,
  FondoColorViewDecoratorType,
} from '@extras_mg/viewDecorators'

const TIPOS_COMPATIBLES = [
  BordeIzquierdoColorViewDecoratorType.getType(),
  FondoColorViewDecoratorType.getType(),
]

/**
 * De donde sale el color de cada fila.
 *
 * Nombres de tipo y forma de configuracion identicos a los de premium, para
 * reemplazar su registro sin dejar entradas duplicadas en el menu y para que
 * cualquier decoracion ya guardada con esos tipos siga funcionando.
 */

export class ColorPorSeleccionValueProviderType extends DecoratorValueProviderType {
  static getType() {
    return 'single_select_color'
  }

  getName() {
    return 'Color de la opcion'
  }

  getDescription() {
    return 'Usa el color que ya tiene la opcion del campo de seleccion unica.'
  }

  getIconClass() {
    return 'iconoir-list'
  }

  getCompatibleDecoratorTypes() {
    return TIPOS_COMPATIBLES
  }

  getFormComponent() {
    return FormaColorPorSeleccion
  }

  getDefaultConfiguration({ fields }) {
    // Se preselecciona el primer campo de seleccion unica: asi el decorador
    // pinta algo desde el primer clic en vez de aparecer vacio.
    const primero = fields.find((f) => f.type === 'single_select')
    return { field_id: primero ? primero.id : null }
  }

  getValue({ options, fields, row }) {
    const idCampo = options?.field_id
    if (!idCampo) {
      return ''
    }
    // Las filas guardan sus valores bajo la llave field_<id>.
    const valor = row[`field_${idCampo}`]
    // Una seleccion unica vacia es null; una con valor trae {id, value, color}.
    return valor?.color || ''
  }
}

export class ColorCondicionalValueProviderType extends DecoratorValueProviderType {
  static getType() {
    return 'conditional_color'
  }

  getName() {
    return 'Color por condiciones'
  }

  getDescription() {
    return 'Aplica el primer color cuyas condiciones cumpla la fila.'
  }

  getIconClass() {
    return 'iconoir-filter'
  }

  getCompatibleDecoratorTypes() {
    return TIPOS_COMPATIBLES
  }

  getFormComponent() {
    return FormaColorCondicional
  }

  getDefaultConfiguration() {
    return { colors: [] }
  }

  getValue({ options, fields, row }) {
    // Gana el primero que cumpla, que es como se leen las reglas de arriba
    // abajo y como estan guardadas las 569 que ya existen.
    for (const regla of options?.colors || []) {
      const filtros = regla.filters || []
      // Una regla sin condiciones aplica siempre: es el "resto de los casos".
      if (filtros.length === 0) {
        return regla.color || ''
      }
      const cumple = matchSearchFilters(
        this.app.$registry,
        regla.operator || 'AND',
        filtros,
        regla.filter_groups || [],
        fields,
        row
      )
      if (cumple) {
        return regla.color || ''
      }
    }
    return ''
  }
}
